import React from 'react';
import WhyCard from './whyCard/whyCard';
import WhyLogo1 from '../../assets/cardicon1.svg';
import WhyLogo2 from '../../assets/cardicon2.svg';
import WhyLogo3 from '../../assets/cardicon3.svg';
import WhyLogo4 from '../../assets/cardicon4.svg';
import WhyLogo5 from '../../assets/cardicon5.svg';
import WhyLogo6 from '../../assets/cardicon6.svg';
import './whyCardList.css'; 

const WhyCardList = () => {
    const cards = [
      {
        icon: WhyLogo1,
        title: 'Instant Access',
        content: 'Browse through a library of powerful tools and software, categorized for every need—AI/ML, Data Science, Reporting, and more.'
      },
      {
        icon: WhyLogo2,
        title: 'Customizable Environments',
        content: 'Tailor your workspace to fit your unique requirements.'
      },
      {
        icon: WhyLogo3,
        title: 'No Installations',
        content: 'Access tools directly in your browser, without any local setup.'
      },
      {
        icon: WhyLogo4,
        title: 'Extensive Tool Library',
        content: 'From databases to AI tools, explore a wide range of pre-configured options.'
      },
      {
        icon: WhyLogo5,
        title: 'Collaborative Workspaces',
        content: 'Work with your team in real-time on the same environment.'
      },
      {
        icon: WhyLogo6,
        title: 'Pay-as-You-Go',
        content: 'Only pay for what you use with our transparent billing system.'
      },
    ];
  
    return (
      <div className="why-card-list">
        {cards.map((card, index) => (
          <WhyCard key={index} {...card} index={index} />
        ))}
      </div>
    );
  };

export default WhyCardList; 